module.exports = __webpack_public_path__ + "img/box-smart.120e0682.png";